<template>
  <div>
    <v-col style="text-align: center">
      <v-row>
        <v-col cols="12" sm="12" lg="12" class="">
          <img :src="imagen" class="header-brand-img-alert" alt="logo" />
          <label class="label-negrita">{{ msj }}</label>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
export default {
  props: {
    erroCode: {
      default: 1,
      type: Number,
    },
  },
  data: () => ({
    basePath: process.env.VUE_APP_CONTEXT_PATH,
    entityConfig: {},
    errorcodes: [709, 615, 724, 725, 727, 728, 734, 713],
    valueCode: 0,
  }),

  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
  },

  computed: {
    imagen() {
      return this.errorcodes.includes(this.erroCode)
        ? this.basePath + "assets/images/globals/c-card-not-found.svg"
        : this.basePath + "assets/images/globals/error.svg"
    },

    msj() {
      return this.errorcodes.includes(this.erroCode)
        ? "No se encontraron datos."
        : "Oh no, algo ha ido muy mal..."
       
    },
  },

  watch: {
    erroCode(val) {
     this.erroCode = val;
      this.$forceUpdate(); 
    },
  },
};
</script>
